'use client';
import { styled } from '@mui/material';
import { Box, BoxProps, Stack, StackProps } from '@mui/material';

export const CarouselSideArrowContainer: React.ComponentType<BoxProps & { isLeft: boolean }> =
  styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isLeft',
  })<{
    isLeft: boolean;
  }>(({ isLeft }) => ({
    position: 'absolute',
    zIndex: 2,
    top: 0,
    insetInlineStart: isLeft ? 'none' : 0,
    insetInlineEnd: isLeft ? 0 : 'none',
    bottom: 0,
    width: '70px',
    height: '100%',
    background: `linear-gradient(${
      isLeft ? '270deg' : '90deg'
    }, rgba(255,255,255,0), rgba(255,255,255,1))`,
    pointerEvents: 'none',
  }));

export const CarouselSideArrowBtn: React.ComponentType<StackProps & { isLeft: boolean }> = styled(
  Stack,
  {
    shouldForwardProp: (prop) => prop !== 'isLeft',
  },
)<{
  isLeft: boolean;
}>(({ theme, isLeft }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  marginInlineStart: isLeft ? 'auto' : theme.spacing(1),
  marginInlineEnd: isLeft ? theme.spacing(1) : 'auto',
  width: '40px',
  height: '40px',
  background: '#fff',
  borderRadius: '50%',
  border: '1px solid #ECECEC',
  pointerEvents: 'all',
}));
